import React from 'react';
import {
        Show,
        ShowButton,
        Tab,
        TabbedShowLayout,
        DateField,
        List,
        Edit,
        Create,
        Datagrid,
        TextField,
        EditButton,
        ReferenceInput,
        ReferenceManyField,
        SingleFieldList,
        ChipField,
        SelectInput,
        SimpleForm,
        TextInput,
        NumberInput,
        Filter,
} from 'react-admin';

import LinkAnyFieldButton from './LinkAnyFieldButton';


const RuleFilter = props => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <ReferenceInput
            label="Name Space"
            source="nameSpace"
            reference="nameSpace"
            allowEmpty
        >
            <SelectInput optionText="firstName" />
        </ReferenceInput>
    </Filter>
);

//<LinkAnyFieldButton to="/Scope/:scopeId/show">
export const RuleList = props => (
    <List {...props} filters={<RuleFilter />}>
        <Datagrid>
            <TextField source="name" />
            <TextField source="type" />
            <TextField source="source" />
            <TextField source="key" />
            <TextField source="value" />
                <ReferenceManyField label="Public Scope" reference="ScopeRuleView" target="ruleId" >
                <SingleFieldList linkType={false} >
                    <LinkAnyFieldButton to="/Scope/:scopeId/show">
                        <ChipField source="scopeName" />
                    </LinkAnyFieldButton>
                </SingleFieldList>
            </ReferenceManyField>
            <ReferenceManyField label="Token Scope" reference="ScopeTokenruleView" target="ruleId" >
                <SingleFieldList linkType={false} >
                    <LinkAnyFieldButton to="/Scope/:scopeId/show">
                        <ChipField source="scopeName" />
                    </LinkAnyFieldButton>
                </SingleFieldList>
            </ReferenceManyField>
            <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

const RuleTitle = ({ record }) => {
    return <span>Rule: {record ? `${record.name}` : ''}</span>;
};

export const RuleEdit = props => (
    <Edit title={<RuleTitle />} {...props}>
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="name" />
            <TextInput source="nameSpace" />
            <NumberInput source="expires" />
        </SimpleForm>
    </Edit>
);

export const RuleCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="nameSpace" />
            <NumberInput source="expires" />
        </SimpleForm>
    </Create>
);

export const RuleShow = props => (
    <Show title={<RuleTitle />} {...props}>
        <TabbedShowLayout>
            <Tab label="summary" >
                <TextField source="name" />
                <TextField source="type" />
                <TextField source="source" />
                <TextField source="key" />
                <TextField source="value" />
                <DateField label="Publication date" source="createdAt" />
            </Tab>
            <Tab label="Usage" >
                <ReferenceManyField label="Public Scope" reference="ScopeRuleView" target="ruleId" linkType="none" >
                    <SingleFieldList linkType={false} >
                        <LinkAnyFieldButton to="/Scope/:scopeId/show">
                            <ChipField source="scopeName" />
                        </LinkAnyFieldButton>
                    </SingleFieldList>
                </ReferenceManyField>
                <ReferenceManyField label="Token Scope" reference="ScopeTokenruleView" target="ruleId" linkType="none" >
                    <SingleFieldList linkType={false} >
                        <LinkAnyFieldButton to="/Scope/:scopeId/show">
                            <ChipField source="scopeName" />
                        </LinkAnyFieldButton>
                    </SingleFieldList>
                </ReferenceManyField>
            </Tab>
        </TabbedShowLayout>
    </Show>
);
